export function idFromPrefix(idPrefix, inputName) {
  return idPrefix ? "".concat(idPrefix, "--").concat(inputName) : null;
}